import React from 'react';
import { string, func, object, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Illustration from 'foundations/Illustrations/Illustration';

import styles from './HotspotSelfcareA.css';

const HotspotSelfcareA = ({
  colorScheme,
  description,
  highlighted,
  imageUrl,
  label,
  link,
  onClick,
  title,
  withIllustration
}) => (
  <div className={classnames(colorScheme, styles.wrapper)}>
    <div className={styles.container}>
      <p className={classnames('p', styles.label)}>{label}</p>

      <h1 className={classnames('section-title', styles.title)}>
        {highlighted && <span className={styles.highlight}>{highlighted}<br/></span>}
        {title}
      </h1>

      {
        description && <p className={classnames('p', styles.description)}>{description}</p>
      }

      <LinkFreeStanding
        className={styles.link}
        size="m"
        icon={{
          direction: 'right',
          name: 'arrow-right',
          type: '20'
        }}
        onClick={onClick}  
        withBouncing
      >
        {link}
      </LinkFreeStanding>

      {
        withIllustration &&
          <Illustration
            name={withIllustration.name}
            size={withIllustration.size}
            customClasses={styles.illustration}
          />
      }

      {
        imageUrl &&
          <div className={styles.image} style={{ backgroundImage: `url(${imageUrl})` }} />
      }
    </div>
  </div>
);

HotspotSelfcareA.propTypes = {
  colorScheme: oneOf([
    'lb01',
    'lb02',
    'lb03',
    'lb04',
    'lb05',
    'lb06'
  ]),
  description: string,
  highlighted: string,
  imageUrl: string,
  label: string.isRequired,
  link: string.isRequired,
  onClick: func,
  title: string.isRequired,
  withIllustration: object,
};

HotspotSelfcareA.defaultProps = {
  colorScheme: 'lb01'
};

HotspotSelfcareA.displayName = 'HotspotSelfcareA';

export default HotspotSelfcareA;


// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Selfcare/HotspotA/HotspotSelfcareA.js